import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "../../hooks/useForm";
import { Direcciones } from "../Otros/Direcciones";
import { Unidades } from "../Otros/Unidades";
import { Grado } from "../Otros/Grado";
import { Escalafon } from "../Otros/Escalafon";
import { BuscarParticipante } from "./BuscarParticipante";
import { PrecalificadoresPorDireccion } from "../Otros/PrecalificadoresPorDireccion";
import { useParams, useSearchParams } from "react-router-dom";
import Swal from "sweetalert2";
import { actualizarParticipanteApi } from "../../utils/Datos";
import { selectUser } from "../../reducers/userSlice";
import { useSelector } from "react-redux";
import { Precalificadores } from "../Otros/Precalificadores";
import { PrecalificadoresAll } from "../Otros/PrecalificadoresAll";

const SelectGrado = ({ updateValue, nuevoValue, disabled }) => {
  return (
    <Grado
      updateValue={updateValue}
      nuevoValue={nuevoValue}
      disabled={disabled}
    />
  );
};
const SelectEscalafon = ({ updateValue, nuevoValue, disabled }) => {
  return (
    <Escalafon
      updateValue={updateValue}
      nuevoValue={nuevoValue}
      disabled={disabled}
    />
  );
};
const SelectPrecalificador = ({
  nombreCampo,
  updateValue,
  nuevoValue,
  disabled,
  idProcess,
}) => {
  /*
  return (
    <PrecalificadoresPorDireccion
      direccion={idDireccion}
      updateValue={updateValue}
      nuevoValue={nuevoValue}
      disabled={disabled}
      idProcess={idProcess}
      soloDireccion={true}
    />
  );*/
  
  return (
    <PrecalificadoresAll
      nombreCampo={nombreCampo}
      updateValue={updateValue}
      nuevoValue={nuevoValue}
      disabled={disabled}
      idProcess={idProcess}
    ></PrecalificadoresAll>
  );
};

export const ActualizarParticipante = ({ limpiar }) => {
  const user = useSelector(selectUser);
  const { id_process } = useParams();
  const [participante, setParticipante] = useState(null);
  const [cargando, setCargando] = useState(true);
  const [formValues, handleInputChange, reset, updateValue, updateState] =
    useForm({
      rut: "",
      nombre: "",
      direccion: "",
      unidad: "",
      precalificadores: "",
      profesion: "",
      escalafon: "",
      grado: "",
      motivo: "",
    });

  const {
    rut,
    nombre,
    direccion,
    unidad,
    precalificadores,
    profesion,
    escalafon,
    grado,
    motivo,
  } = formValues;

  const handleSubmit = () => {
    setCargando(true);
    console.log(grado);

    const body = {
      id_participant: participante.id_participant,
      id_officer: parseInt(participante.id_officer),
      id_prequalifiers: parseInt(precalificadores),
      id_process: parseInt(id_process),
      nameDmunicipal: direccion,
      nameUmunicipal: unidad,
      id_profile: parseInt(participante.id_profile),
      gradeOfficer: parseInt(grado),
      scale_officer: escalafon,
      comment: motivo,
      comment_history: motivo,
      user_creator: user.user.username,
      status: true,
    };
    actualizarParticipanteApi(body).then((respuesta) => {
      if (respuesta.status === true) {
        Swal.fire({
          title: "Listo",
          text: "Participante actualizada/o correctamente",
          icon: "success",
          confirmButtonText: "Ok",
        });
      } else {
        Swal.fire({
          title: "Error",
          text:
            respuesta.errores ??
            "Ocurrió un error, por favor vuelva a intentarlo",
          icon: "error",
          confirmButtonText: "Ok",
        });
      }
      setCargando(false);
    });
  };

  useEffect(() => {
    reset();
  }, [limpiar]);

  useEffect(() => {
    console.log(user.user.name);
    if (participante != null) {
      console.log("Actualizados");
      console.log(participante.precalificadores);
      updateState([
        { name: "rut", value: participante.officerRut },
        { name: "nombre", value: participante.officerName },
        { name: "direccion", value: participante.nameDmunicipal },
        { name: "unidad", value: participante.nameUmunicipal },
        { name: "profesion", value: participante.profession },
        { name: "escalafon", value: participante.scale_officer },
        { name: "grado", value: participante.gradeOfficer ?? 15 },
        { name: "precalificadores", value: participante.id_prequalifiers },
      ]);
    }
  }, [participante]);

  return (
    <div className="modal fade " id="m-acParticipante" tabIndex="-1 " aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered mw-900px">
        <div className="modal-content">
          <div className="modal-header">
            <h4>Actualizar participante del Proceso</h4>
            <div
              className="btn btn-sm btn-icon btn-active-color-primary "
              data-bs-dismiss="modal"
            >
              <span className="svg-icon svg-icon-1">X</span>
            </div>
          </div>
          <div className="modal-body py-lg-10 px-lg-10 ">
            <div className="row">
              <div className="col-lg-4 col-sm-12">
                <BuscarParticipante
                  setParticipante={setParticipante}
                  idProcess={id_process}
                  setCargando={setCargando}
                  limpiar={limpiar}
                />
              </div>
            </div>
            <div className="row mt-4">
              <div className="col-lg-4 col-sm-12">
                <label>Rut</label>
                <input
                  type="text"
                  className="form-control mb-5"
                  placeholder="Rut"
                  onChange={handleInputChange}
                  value={rut}
                  name="rut"
                  readOnly={participante != null}
                  disabled={participante == null}
                />
              </div>

              <div className="col-lg-4 col-sm-12">
                <label>Nombre</label>
                <input
                  disabled={participante == null}
                  type="text"
                  className="form-control mb-5"
                  placeholder="Nombre"
                  onChange={handleInputChange}
                  value={nombre}
                  name="nombre"
                />
              </div>

              <div className="col-lg-4 col-sm-12 mb-4">
                <label>Dirección</label>
                {/*<SelectDirecciones
                  updateValue={updateValue}
                  nuevoValue={direccion}
                  disabled={participante == null}
                />*/}
                <input
                  disabled={participante == null}
                  type="text"
                  className="form-control mb-5"
                  placeholder="Dirección Municipal"
                  onChange={handleInputChange}
                  value={direccion}
                  name="direccion"
                />
              </div>
              <div className="col-lg-4 col-sm-12 mb-4">
                <label>Unidad</label>
                <input
                  disabled={participante == null}
                  type="text"
                  className="form-control mb-5"
                  placeholder="Unidad Municipal"
                  onChange={handleInputChange}
                  value={unidad}
                  name="unidad"
                />
                {/*<SelectUnidades
                  idDireccion={direccion}
                  updateValue={updateValue}
                  nuevoValue={unidad}
                  disabled={participante == null}
                />*/}
              </div>

              <div className="col-lg-4 col-sm-12 mb-4">
                <label>Precalificador</label>
                <SelectPrecalificador
                  nombreCampo={'precalificadores'}
                  nuevoValue={precalificadores}
                  updateValue={updateValue}
                  disabled={participante == null}
                  idProcess={id_process}
                />
              </div>
              <div className="col-lg-4 col-sm-12 mb-4">
                <label>Profesión</label>
                <input
                  disabled={participante == null}
                  type="text"
                  className="form-control mb-5"
                  placeholder="Profesión"
                  onChange={handleInputChange}
                  value={profesion}
                  name="profesion"
                />
              </div>
              <div className="col-lg-4 col-sm-12 mb-4">
                <label>Escalafón</label>
                <SelectEscalafon
                  nuevoValue={escalafon}
                  updateValue={updateValue}
                  disabled={participante == null}
                />
              </div>

              <div className="col-lg-4 col-sm-12 ">
                <label>Grado</label>
                <SelectGrado
                  nuevoValue={grado}
                  updateValue={updateValue}
                  disabled={participante == null}
                />
              </div>
            </div>
            <label>Motivo</label>
            <textarea
              className="form-control mb-8"
              rows="5"
              cols="5"
              placeholder="Motivo"
              name="motivo"
              value={motivo}
              onChange={handleInputChange}
              disabled={participante == null}
            ></textarea>

            <div className="d-flex justify-content-end ">
              <button
                className="btn btn-sm btn-danger mt-8"
                onClick={handleSubmit}
                disabled={cargando}
              >
                {cargando ? " Actualizando..." : " Actualizar"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
